var $befba97b83d35197$exports = {};
$befba97b83d35197$exports = {
  "help": "\u5E2E\u52A9",
  "info": "\u4FE1\u606F"
};
export { $befba97b83d35197$exports as default };